import React, { Suspense, lazy } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components
const OrderList = lazy(() => import('../Pages/OrderList'));
const OrderView = lazy(() => import('../Pages/OrderView'));
const AddOrder = lazy(() => import('../Pages/AddOrder'));
const EditOrder = lazy(() => import('../Pages/EditOrder'));
const DigitalMenuOrders = lazy(() => import('../Pages/DigitalMenuOrders'));

// Loading component for Suspense fallback
const Loading = () => (
  <LoadingOverlay
    active={false}
    spinner={<FadeLoader color={"#36D7B7"} />}
    text="Loading..."
    styles={{
      overlay: (base) => ({
        ...base,
        background: "rgba(255, 255, 255, 0.8)",
      }),
      content: (base) => ({
        ...base,
        color: "#36D7B7",
      }),
    }}
  >
    <div style={{ height: "100vh" }}></div>
  </LoadingOverlay>
);

function OrderRoute() {
  const history = useHistory();

  return (
    <Switch>
      <Route
        exact
        path="/:lng/sales/orders"
        render={() => (
          <Suspense fallback={<Loading />}>
            <OrderList history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/list"
        render={() => (
          <Suspense fallback={<Loading />}>
            <OrderList history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/add"
        render={() => (
          <Suspense fallback={<Loading />}>
            <AddOrder history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/edit/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <EditOrder history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/view/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <OrderView history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/sales/digital-menu-orders"
        render={() => (
          <Suspense fallback={<Loading />}>
            <DigitalMenuOrders history={history} />
          </Suspense>
        )}
      />
    </Switch>
  );
}

export default withNamespaces()(OrderRoute);
